import { Capacitor } from '@capacitor/core'
import { Device } from "@capacitor/device"
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics"

/**
 * Registers Firebase Analytics to collect data
 */
async function register() {
  if (Capacitor.getPlatform() === "web") {
    await FirebaseAnalytics.initializeFirebase({
      apiKey: "AIzaSyD6s6upFBLMpsgnfcfKmD3SEQZvOcp0p_s",
      authDomain: "city-hall-kiosk-vb-connect.firebaseapp.com",
      databaseURL: "https://city-hall-kiosk-vb-connect.firebaseio.com",
      projectId: "city-hall-kiosk-vb-connect",
      storageBucket: "city-hall-kiosk-vb-connect.appspot.com",
      messagingSenderId: "178058423479",
      appId: "1:178058423479:web:5f4853a578fc65dac4b132",
      measurementId: "G-1VQG9BGR2N",
    })
  }

  // Disable analytics collection in the dev environment
  if (process.env.NODE_ENV === "development") {
    FirebaseAnalytics.setCollectionEnabled({ enabled: false })
  }
}

/**
 * Call analytics
 * @param  {string} route [path for the route]
 */
async function logAnalytics(route, screenName, error) {
  const info = await Device.getInfo()

  if (info.platform === "ios" || info.platform === "android") {
    FirebaseAnalytics.setScreenName({
      screenName,
    })
  }
}

export { logAnalytics, register }